import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../../utils/api";
import AdminNav from "../../components/AdminNav";

const Dashboard = () => {
  const [stats, setStats] = useState({
    pendingApprovals: 0,
    totalProducts: 0,
    totalOrders: 0,
    totalUsers: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const statsResponse = await api.get("/admin/stats");
      setStats(statsResponse.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center text-gold-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <AdminNav />
      <div className="container mx-auto px-4 py-8">
        <h1 className="heading-metallic text-3xl mb-8">Admin Dashboard</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <Link to="/admin/products" className="block">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card cursor-pointer">
              <h3 className="text-lg font-semibold text-white mb-2">Total Products</h3>
              <p className="text-4xl font-bold text-gold-500">{stats.totalProducts}</p>
              <span className="text-sm text-gray-400 hover:text-gold-500 mt-2 inline-block">
                Manage Products →
              </span>
            </motion.div>
          </Link>

          <Link to="/admin/users?tab=all" className="block">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="card cursor-pointer">
              <h3 className="text-lg font-semibold text-white mb-2">Total Users</h3>
              <p className="text-4xl font-bold text-gold-500">{stats.totalUsers}</p>
              <span className="text-sm text-gray-400 hover:text-gold-500 mt-2 inline-block">
                Manage Users →
              </span>
            </motion.div>
          </Link>

          <Link to="/admin/users" className="block">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="card cursor-pointer">
              <h3 className="text-lg font-semibold text-white mb-2">Pending Approvals</h3>
              <p className="text-4xl font-bold text-gold-500">{stats.pendingApprovals}</p>
              <span className="text-sm text-gray-400 hover:text-gold-500 mt-2 inline-block">
                Review Applications →
              </span>
            </motion.div>
          </Link>

          <Link to="/admin/orders" className="block">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="card cursor-pointer">
              <h3 className="text-lg font-semibold text-white mb-2">Total Orders</h3>
              <p className="text-4xl font-bold text-gold-500">{stats.totalOrders}</p>
              <span className="text-sm text-gray-400 hover:text-gold-500 mt-2 inline-block">
                Manage Orders →
              </span>
            </motion.div>
          </Link>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold text-white mb-4">Quick Actions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Link to="/admin/traffic" className="btn-secondary block text-center">
              View Traffic
            </Link>
            <Link to="/admin/products" className="btn-secondary block text-center">
              Add Product
            </Link>
            <Link to="/admin/users" className="btn-secondary block text-center">
              Review Applications
            </Link>
            <Link to="/admin/orders" className="btn-secondary block text-center">
              View Orders
            </Link>
            <Link to="/admin/settings" className="btn-secondary block text-center">
              Site Settings
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
